import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { initializeApiAuth } from './services/api';
import { useAuth } from './hooks';
import { Header, ProtectedRoute } from './components/layout';
import { HomePage, LoginPage, SignupPage, ChatPage, ProfilePage, AdminDashboard, ProviderRegistrationPage, WellnessPage, HealthScorePage, ForgotPasswordPage, ResetPasswordPage, ChangePasswordPage } from './pages';
import './styles/global.css';

// Initialize API auth handlers to break circular dependency
// This must be done after store is imported but before any API calls
initializeApiAuth(
  () => store.getState().auth.token,
  () => store.dispatch({ type: 'auth/logoutSync' })
);

const AppContent: React.FC = () => {
  const { checkAuth } = useAuth();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePasswordPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/provider-registration"
            element={
              <ProtectedRoute>
                <ProviderRegistrationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wellness"
            element={
              <ProtectedRoute>
                <WellnessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/health-score"
            element={
              <ProtectedRoute>
                <HealthScorePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;
